export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    } else  {
        return String(error);
    }
}

export function osMajorVersionAndroid(): number | undefined {
    const match = /Android[\s-]+(\d+)/.exec(navigator.userAgent);
    return match ? parseInt(match[1]!) : undefined;
}

export function osMajorVersionIos(): number | undefined {
    const match = /CPU.*OS (\d+)/i.exec(navigator.userAgent);
    return match ? parseInt(match[1]!) : undefined;
}